import { render, staticRenderFns } from "./ClinicConceptForm.vue?vue&type=template&id=6dcd4916&scoped=true"
import script from "./ClinicConceptForm.vue?vue&type=script&lang=js"
export * from "./ClinicConceptForm.vue?vue&type=script&lang=js"
import style0 from "./ClinicConceptForm.vue?vue&type=style&index=0&id=6dcd4916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcd4916",
  null
  
)

export default component.exports